import { Component } from '@angular/core';

@Component({
  selector: 'app-refresh-page-warning',
  templateUrl: './refresh-page-warning.component.html',
  styleUrls: ['./refresh-page-warning.component.scss']
})
export class RefreshPageWarningComponent {

}
